const MAX_VALUE_SIZE   = 1024 * 64
const NEXT_PART_SYMBOL = "@"
const NEXT_PART_SYFFIX = "."

export default class LStorage implements Storage {
    private backend: Storage;
    length: number;
    prefix: string;

    constructor(backend: Storage, prefix: string) {
        this.backend = backend;
        this.length = backend.length;
        this.prefix = prefix;

        if (typeof backend.sync === "function") {
            (this as any).sync = (callback: any) => {
                backend.sync(callback);
            }
        }
    }

    setLocalStoragePrefix(prefix: string) {
        this.prefix = prefix;
    }

    clear(): void {
        if (!this.backend.length) {
            return;
        }

        const toRemove: string[] = [];
        for (let i = 0; i < this.backend.length; ++i) {
            const next = this.backend.key(i);
            if (next && next.startsWith(this.prefix)) {
                toRemove.push(next);
            }
        }

        for (const next of toRemove) {
            this.backend.removeItem(next);
        }
        this.length = this.backend.length;
    }

    key(index: number): string | null {
        return this.backend.key(index);
    }

    setItem(key: string, value: string): void {
        if (!value || value.length === undefined || value.length === 0) {
            this.writeStringToKey(key, "");
            return;
        }

        let offset = 0;
        while (offset < value.length) {
            let substr = value.substr(offset, MAX_VALUE_SIZE);
            offset += substr.length;

            if (offset < value.length) {
                substr += NEXT_PART_SYMBOL;
            }

            this.writeStringToKey(key, substr);
            key += NEXT_PART_SYFFIX;
        }
    }

    getItem(key: string): string | null {
        let value = this.readStringFromKey(key);
        if (value === null) {
            return null;
        }

        if (value.length === 0) {
            return value;
        }

        while (value[value.length - 1] === NEXT_PART_SYMBOL) {
            value = value.substr(0, value.length - 1);
            key += NEXT_PART_SYFFIX;
            const next = this.readStringFromKey(key);
            value += next === null ? "" : next;
        }


        return value;
    }

    removeItem(key: string): void {
        this.backend.removeItem(this.prefix + key);
        this.length = this.backend.length;
    }

    private writeStringToKey(key: string, value: string) {
        this.backend.setItem(this.prefix + key, value);
        this.length = this.backend.length;
    }

    private readStringFromKey(key: string) {
        return this.backend.getItem(this.prefix + key);
    }

}
